<div class="main-nav-flyout">
    <div class="nav-header">
      <ul>
        <li *ngIf="isMobileApp()" class="nav-col" >
          <a href="com.huronaccelerators-mobile:/device-preferences"><span class="icon-checklist"></span> Device Preferences</a>
        </li>
        <li *ngFor="let link of headerLinks">
          <a [routerLink]="['/' + link.route]">
            <span class="icon {{ link.iconClass }}"></span> {{ link.name }}
          </a>
        </li>
      </ul>
      <a class="close" (click)="closeMenu.emit()"><span class="icon-cross"></span></a>
    </div>
    <div class="nav-body">
      <ul class="main-nav-list">
        <li class="nav-col" *ngFor="let section of sectionLinks">
          <ul>
            <li>
              <a *ngIf="section.route" [routerLink]="['/' + section.route]" [fragment]="section.fragment">
                <span [class]="section.iconClass"></span> {{ section.name }}
              </a>
              <span *ngIf="!section.route">
                <span [class]="section.iconClass"></span> {{ section.name }}
              </span>
              <ul>
                <li *ngFor="let link of section.menuLinks">
                  <a *ngIf="link.route && !link.isExternalRoute" [routerLink]="['/' + link.route]" [fragment]="link.fragment">
                    {{ link.name }}
                  </a>
                  <a *ngIf="link.isExternalRoute" [href]="link.route">
                    {{ link.name }}
                  </a>
                  <span *ngIf="!link.route">
                    {{ link.name }}
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="app-list" *ngIf="applicationLinks.length > 0">
        <li *ngFor="let link of applicationLinks" >
          <a href="{{ link.route }}">
            <span class="icon {{ link.iconClass }}"></span>{{ link.name }}
          </a>
        </li>
      </ul>
  </div>
  